import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TableTracker from "./TableTracker";
import Styles from "../../Style/Main.module.css";
import { Breadcrumbs, Grid, Link, TextField, Tooltip, Autocomplete, IconButton, ListItemText, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../../../images/Group 1000000833.png";
import axios from "axios";
import { useStateValue } from "../../../../Hooks/stateProvider";
import Loader from "../../../../Loader/Loader";
import { encrypt } from "../../../../utils/cipher";
import FilterList from "../../../../components/FilterList";
import { useState } from "react";
import { Box } from "@mui/system";
import { ls } from "../../../../variables";
import { Quarter } from "../../../../variables";
import { errorHandler } from "../../../../utils/errorHandling";
import { previewValidators } from "../../../../utils/validators";
import { LightTooltip } from "../../../../components/LightTooltip";
import Swal from "sweetalert2";
import { alert } from "../../../../utils/sweetAlert";
import AlertDownloadDropDown from "./AlertDownloadDropdown";
import InfoIcon from '@mui/icons-material/Info';

export default function SebiTracker() {

  const fundOptions = ls.get("reportType")['Alert Processing']
  // const [fundOptions, setFundOptions] = useState(
  //       ls.get("reportType")[moduleType]
  //     );
  const fundOptionsObject = ls.get("reportType")['Alert Processing'];
  const Year = ls.get("years");
  const navigate = useNavigate();
  const [{ pageLoading, moduleType, fy_year, quarter, pmsName }, dispatch] = useStateValue();
  const [selectedPMS, setSelectedPMS] = React.useState('');

  const [apiStatus, setApiStatus] = useState();
  const [briefData, setBriefData] = useState({});
  const [selectedQuarter, setQuarter] = React.useState(quarter);
  const [selectedFinancialYear, setFinancialYear] = React.useState(fy_year);
  const [selectedFundname, setSelectedFundname] = useState("");
  const [selectedGuidanceType, setGuidanceType] = React.useState([]);
  const [guidanceTypeOptions, setGuidanceTypeOptions] = React.useState();
  const [receivedData, setReceivedData] = React.useState([]);
  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [openselectBox, setOpenselectBox] = useState(false);
  const [openNestedList, setOpenNestedList] = useState({
    "localCMMTypeData": ["Compliance Reporting Category 1", "Compliance Reporting Category 2"],
    "localRemarksData": [],
    "localStatusData": [],
    "localGuidanceData": []
  });
  const [isInitialFetch, setIsInitialFetch] = useState(true); // State to track fetch type
  const [filteredRows, setFilteredRows] = useState(rows);
  const [dataFetchFlag, setDataFetchFlag] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [finalSubmissionFlag, setFinalSubmissionFlag] = useState(false);
  const [s3FilePath, setS3FilePath] = useState([]);
  const type = moduleType;
  ls.set("pmsName", selectedPMS);

  React.useEffect(() => {
    if (briefData?.pmsName) {
      handlePreviewClick();
      setIsInitialFetch(false)
      setSelectedFundname(briefData?.pmsName);
      dispatch({ type: "pmsName", pmsName: briefData?.pmsName });
    }
  }, [briefData]);

  const handlePreviewClick = async (item) => {

    if (!previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, pmsName)) {
      return;
    }
    dispatch({ type: "SHOW_LOADER" });
    const payload = {
      fy_year: selectedFinancialYear,
      quarter: selectedQuarter,
      pmsName: selectedPMS,
      moduleType: moduleType,
      userType: 'SEBI',
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
      fetchResults: item ? "initial" : "brief", // Set fetchResults based on state
    };


    if (item) {
      setIsInitialFetch(true)
      setSelectedFundname("");
    } else {
      setIsInitialFetch(false)
      payload.pmsName = briefData?.pmsName; // Use briefData for brief fetch
    }

    const encryptedPayload = await encrypt(payload);

    axios
      .post("/api/pms/trackerPageFetchAPI", { payload: encryptedPayload }, {
        withCredentials: true
      })
      .then((tableData) => {
        const GToptions = tableData.data.gudianceTypeArr;
        const data = tableData.data.data;
        setGuidanceTypeOptions(GToptions);
        setReceivedData(data);
        if (item) {
          if (tableData?.data?.emptyInitialData?.length) {
            Swal.fire({
              title: "Data Not Available",
              html: tableData?.data?.emptyInitialData.length === 1
                ? `No Data Found for the Following PMS:<br><br><span style="font-weight: bold;">${tableData?.data?.emptyInitialData.join(', ')}</span></br></br>`
                : `No Data Found for the Following PMSs:<br><br><span style="font-weight: bold;">${tableData?.data?.emptyInitialData.join(', ')}</span></br></br>`,
              icon: "warning",
              confirmButtonColor: "#154063",
              confirmButtonText: "OK",
            });
          }

          const newRows = tableData?.data?.initialData.map((val, id) => ({
            id: id,
            pmsName: val.pmsname,
            total_clauses: val.Total_Count,
            open_clauses: val.Open_SEBI,
            initial_response_received: val.Total_Count,
            clarification_sought: val.Open_PMS,
            final_closure_pending: (parseInt(val.Open_SEBI) + parseInt(val.Open_PMS)),
            // submission_date: val.upload_date
          }));
          // console.log("table to props", newRows)

          dispatch({ type: "HIDE_LOADER" });
          setRows(newRows);
          setFilteredRows(newRows);
          setDataFetchFlag(true);

        }
        else {
          // Handle filtering logic
          setRows(data);
          setFilteredRows(data?.filter((val) => {
            if (openNestedList["localStatusData"].length === 0 && openNestedList["localGuidanceData"].length === 0) {
              return true;
            } else if (openNestedList["localStatusData"].length !== 0 && openNestedList["localGuidanceData"].length !== 0) {
              return openNestedList["localStatusData"].includes(val.alert_status) && openNestedList["localGuidanceData"].includes(val.guidance_type);
            } else {
              return openNestedList["localStatusData"].includes(val.alert_status) || openNestedList["localGuidanceData"].includes(val.guidance_type);
            }
          }));

          setSubmitFlag(tableData?.data?.submitFlag?.status);
          setFinalSubmissionFlag(tableData?.data?.submitFlag?.submited);
          setSubmitMessage(tableData?.data?.submitFlag?.message);
          setS3FilePath(tableData?.data?.s3Location);
          dispatch({
            type: "SEBITrackerData",
            SEBITrackerData: {
              fy_year: selectedFinancialYear,
              quarter: selectedQuarter,
            },
          });
          setDataFetchFlag(true);
          dispatch({ type: "HIDE_LOADER" });
        }


      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        console.log("err.....or", err)
        errorHandler(err, navigate);
      });
  };



  const getFilteredData = () => {
    setFilteredRows(rows.filter((val) => {
      if (openNestedList["localStatusData"].length === 0 && openNestedList["localGuidanceData"].length === 0) {
        return true;
      } else if (openNestedList["localStatusData"].length !== 0 && openNestedList["localGuidanceData"].length !== 0) {
        return openNestedList["localStatusData"].includes(val.alert_status) && openNestedList["localGuidanceData"].includes(val.guidance_type);
      } else {
        return openNestedList["localStatusData"].includes(val.alert_status) || openNestedList["localGuidanceData"].includes(val.guidance_type);
      }
    }));
  };

  console.log("s3FilePath", s3FilePath)

  const handleDownload = async () => {
    const downloadPayload = {
      s3Location: decodeURI(s3FilePath[0]?.s3_location),
      moduleType: moduleType,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
    };
    const encryptedPayload = await encrypt(downloadPayload);
    const result = axios.post(
      "/api/pms/downloadReport",
      { payload: encryptedPayload },
      {
        withCredentials: true,
      }
    );
    result
      .then((response) => {
        if (response.data.success) {
          window.open(response.data.data, "_self");
        }
      })
      .catch((err) => {
        errorHandler(err, navigate);
      });
  };

  const finalSubmit = async () => {
    const encryptedPayload = await encrypt({
      "moduleType": moduleType,
      "fy_year": selectedFinancialYear,
      "quarter": selectedQuarter,
      "pmsName": ls.get("selectedFundname"),
      "totalClosed": receivedData?.length,
      "authToken": ls.get("authToken"),
      "refreshToken": ls.get("refreshToken"),
      "userType": 'SEBI'
    });
    Swal.fire({
      icon: "warning",
      title: "Are you sure about your submission?",
      text: "Responses once recorded, shall not be reverted later.",
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (val) => {
      if (val.isConfirmed) {
        const response = await axios.post('/api/pms/closureRecords', { payload: encryptedPayload }, {
          withCredentials: true
        });
        if (response?.data?.success) {
          alert("Success !!", "Your responses has been successfully captured.", "success");
          await handlePreviewClick();
        } else {
          alert("Your responses were not recorded.", "Please contact administrator.", "warning");
        }
      }
    });
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredData = receivedData?.filter((row) => {
      const { fy_year, quarter, pmsName, instance_count, alert_remarks, sebi_remarks, ...rest } = row;
      return Object.values(rest).some((val) =>
        val?.toString().toLowerCase().includes(query.toLowerCase())
      );
    });
    setFilteredRows(filteredData);
  };

  React.useEffect(() => {
    if (fy_year !== "" && quarter !== "" && pmsName !== "") {
      handlePreviewClick();
    }
  }, []);

  React.useEffect(() => {
    setReceivedData([]);
    dispatch({ type: "fy_year", fy_year: selectedFinancialYear });
    dispatch({ type: "quarter", quarter: selectedQuarter });
    dispatch({ type: "pmsName", pmsName: selectedPMS });
  }, [selectedFinancialYear, selectedQuarter, selectedPMS]);

  const handlePMSChange = (pmsName) => {
    // console.log("Selected PMS:", pmsName);
    setSelectedPMS(pmsName);
  };

  const handleSelectAll = (fundOptions) => {
    if (fundOptions?.every((id) => selectedPMS?.includes(id.code))) {
      setSelectedPMS([]);
    } else {
      setSelectedPMS(fundOptions.map((val) => val.code));
    }
  };

  const handleSelect = (id) => {
    //if it is already available then remove, if not then add.
    if (selectedPMS?.includes(id)) {
      setSelectedPMS(selectedPMS.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedPMS([...selectedPMS, id]);
    }
  };
  ls.set("selectedFundname", selectedFundname.toUpperCase())

  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/welcome")}
            >
              Welcome
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={() => { handlePreviewClick(true); }}
            >
              ALERT
            </Link>
            {selectedFundname && (
              <Link underline="hover" color="inherit">
                {selectedFundname.toUpperCase()}
              </Link>
            )}
          </Breadcrumbs>
          {/* <div style={{ display: "flex", gap: "1rem", alignItems: "start" }}> */}
          {receivedData?.length > 0 && isInitialFetch === false &&
            <div style={{ display: "flex", gap: "1rem", alignItems: "start" }}>
              <TextField
                sx={{
                  height: "2rem",
                  width: "clamp(10rem,20vw,30rem)",
                  "& .MuiInputBase-root": {
                    height: "2rem"
                  }
                }}

                variant="outlined"
                placeholder="Search Table"
                value={searchQuery}
                onChange={handleSearch}
              />
              {/* <button
                  className={Styles.DownloadBtn}
                  onClick={handleDownload}
                  disabled={s3FilePath?.length > 0 ? false : true}
                  style={{
                    backgroundColor: s3FilePath?.length > 0 ? "#154063" : "#808080",
                    cursor: s3FilePath?.length > 0 ? "pointer" : "default",
                    border: s3FilePath?.length > 0 ? "0.125rem solid #154063" : "0.125rem solid #808080"
                  }}
                >
                  DOWNLOAD
                </button> */}
              <AlertDownloadDropDown fileLocations={{ s3_location: decodeURI(s3FilePath[0]?.s3_location) }} />
            </div>}
          {/* </div> */}
        </div>
        <div className={Styles.HeaderBody}>
          <div>
            <Grid container spacing={2} display="flex">
              <Grid item className={Styles.dataForm} xs={12} sm={6} md={2}>
                <FormControl
                  variant="standard"
                  sx={{ m: 0, height: "100%", width: "100%" }}
                >
                  <span>PMS</span>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    filterOptions={(options, state) => {
                      const filteredPMS = options.filter((option) =>
                        option.PMS.toLowerCase().includes(state.inputValue)
                      );
                      return filteredPMS;
                    }}
                    options={[{ code: "Select All", PMS: "Select All" }, ...fundOptionsObject]}
                    getOptionKey={(option) => option.code}
                    getOptionLabel={(option) => option.PMS}
                    renderInput={(params) => {
                      const { endAdornment } = params.InputProps;

                      params.InputProps = {
                        ...params.InputProps,
                        endAdornment: (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {endAdornment}
                            <Tooltip title="Search for the PMS name to obtain the corresponding PMS code" placement="top">
                              <IconButton size="small" sx={{ ml: 1 }}>
                                <InfoIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )
                      };

                      return (
                        <TextField {...params} variant="standard" placeholder={selectedPMS.length > 0 ? selectedPMS.join(",") : "Select PMS"} />
                      )
                    }}
                    renderOption={(params, option) => {  // Rendering first 10 PMS names instead of 455 which causes lag issue
                      if (params['data-option-index'] < 10) {
                        return (
                          <Tooltip
                            title={`${option.PMS}`}
                            placement="top-start"
                            key={option.code}
                          >
                            <MenuItem
                              value={option.code}
                              onClick={() => option.code === "Select All" ? handleSelectAll(fundOptions) : handleSelect(option.code)}
                            >
                              <Checkbox checked={option.code === "Select All" ? fundOptions?.every((id) => selectedPMS.includes(id.code)) : selectedPMS.includes(option.code)} />
                              <ListItemText primary={option.code} />
                            </MenuItem>
                          </Tooltip>
                        )
                      } else return null
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item className={Styles.dataForm} xs={12} sm={6} md={2}>
                <FormControl
                  variant="standard"
                  sx={{ m: 0, height: "100%", width: "100%" }}
                >
                  <span> Financial Year</span>
                  <Select
                    value={selectedFinancialYear}
                    onChange={(e) => setFinancialYear(e.target.value)}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          color: "#000000",
                          "& .MuiMenuItem-root": {
                            padding: 1,
                          },
                        },
                      },
                    }}
                    displayEmpty
                    renderValue={
                      selectedFinancialYear !== ""
                        ? undefined
                        : () => "Select FY"
                    }
                  >
                    {Year.map((name) => (
                      <MenuItem key={name.label} value={name.value}>
                        {name.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item className={Styles.dataForm} xs={12} sm={6} md={2}>
                <FormControl
                  variant="standard"
                  sx={{ m: 0, height: "100%", width: "100%" }}
                >
                  <span>Quarter</span>
                  <Select
                    value={selectedQuarter}
                    onChange={(e) => setQuarter(e.target.value)}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          color: "#000000",
                          "& .MuiMenuItem-root": {
                            padding: 1,
                          },
                        },
                      },
                    }}
                    displayEmpty
                    renderValue={
                      selectedQuarter !== ""
                        ? undefined
                        : () => "Select Quarter"
                    }
                  >
                    {Quarter.map((name) => (
                      <MenuItem key={name.label} value={name.value}>
                        {name.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid
                item
                display="flex"
                xs={12}
                sm={12}
                md={6}
                lg={6}
                className={Styles.dataFormButtonTracker}
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "flex-end",
                  gap: "1rem"
                }}
              >
                <button className={Styles.Preview} onClick={() => {
                  handlePreviewClick(true);
                }}>
                  APPLY
                </button>
                {rows?.length !== 0 && isInitialFetch === false && <button className={Styles.Preview} onClick={(e) => {
                  e.stopPropagation();
                  setOpenselectBox(true);
                }}>
                  FILTER
                </button>}
                {openselectBox && (
                  <Box
                    sx={{
                      bgcolor: "background.paper",
                      width: { xs: "17%", md: "28%" },
                      position: "absolute",
                      right: { xs: "1.2rem", md: "2rem" },
                      backgroundColor: "white",
                      zIndex: "100",
                      boxShadow: 6,
                      marginTop: "0.5rem",
                      borderRadius: "1rem",
                      top: "10rem"
                    }}
                  >
                    <FilterList handleOpen={setOpenselectBox} open={openselectBox} openNestedList={openNestedList} setOpenNestedList={setOpenNestedList} trackerPageFetch={getFilteredData} moduleType={type} guidanceTypeOptions={guidanceTypeOptions} />
                  </Box>
                )}
                {receivedData?.length > 0 && isInitialFetch === false &&
                  <LightTooltip title={!submitFlag ? `${submitMessage}` : ""} placement="top-start">
                    <span>
                      <button className={Styles.Preview} disabled={!submitFlag}
                        style={{
                          backgroundColor: submitFlag ? "#154063" : "#808080",
                          cursor: submitFlag ? "pointer" : "default",
                          border: submitFlag ? "0.125rem solid #154063" : "0.125rem solid #808080"
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          finalSubmit();
                        }}>SUBMIT
                      </button>
                    </span>
                  </LightTooltip>
                }
              </Grid>
            </Grid>
          </div>
        </div>

        <div className={Styles.tableBody}>
          {!dataFetchFlag && <Loader />}
          {dataFetchFlag && (
            <TableTracker
              GTtype={selectedGuidanceType}
              tableData={filteredRows}
              trackerPageFetch={handlePreviewClick}
              isInitialFetch={isInitialFetch}
              setIsInitialFetch={setIsInitialFetch}
              setBriefData={setBriefData}
              filters={{ fy_year, quarter, pmsName }}
              submissionFlag={finalSubmissionFlag}
            />
          )}
          {(pageLoading === false || pageLoading === undefined) && !dataFetchFlag && (
            <img
              className="image"
              src={logo}
              alt="Group 1000000833.png"
            />
          )}
        </div>
      </div>
    </>
  );
}
